import { useCallback } from "react";
import { useAppSelector } from "../../../store";
import type { TreeNodeData } from "../../../services/TreeView/TreeViewAPI.types";
import { useWatchlistItemToggle } from "../../ActionReports/hooks/useWatchlistToggle";
import { makeWatchlistKey, buildWatchlistSet } from "../watchlistUtils";

export interface UseTreeViewWatchlistToggleReturn {
  toggleWatchlist: (node: TreeNodeData) => Promise<void>;
  isInWatchlist: (node: TreeNodeData) => boolean;
}

export const useTreeViewWatchlistToggle = (): UseTreeViewWatchlistToggleReturn => {
  const { watchlistItems } = useAppSelector((state) => state.watchlist);
  const toggleWatchlistItem = useWatchlistItemToggle();

  const isInWatchlist = useCallback(
    (node: TreeNodeData): boolean => {
      const watchlistSet = buildWatchlistSet(watchlistItems);
      return watchlistSet.has(makeWatchlistKey(node.aff, node.abo));
    },
    [watchlistItems],
  );

  const toggleWatchlist = useCallback(
    async (node: TreeNodeData): Promise<void> => {
      await toggleWatchlistItem({ aff: node.aff.toString(), aboNumber: node.abo.toString() }, isInWatchlist(node));
    },
    [isInWatchlist, toggleWatchlistItem],
  );

  return { toggleWatchlist, isInWatchlist };
};
